module.exports = __webpack_public_path__ + "assets/img/7465792a8e8ed8b0a73bdee36cfee369.png";